/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class DeviceTraitsEvents {
}
DeviceTraitsEvents.DEVICE_TRAITS_CHANGED = 'dell.sirius.device-traits.traits-changed';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGV2aWNlLXRyYWl0cy5ldmVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2hhcmVkL2RldmljZS10cmFpdHMvZXZlbnRzL2RldmljZS10cmFpdHMuZXZlbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGtCQUFrQjs7QUFDSix3Q0FBcUIsR0FBRywwQ0FBMEMsQ0FBQyJ9